import React from "react";
import { SaveButton, SimpleForm, TextInput, useNotify } from "react-admin";

import useAuthMutations from "../../store/mutations/useAuthMutations";

import useValidators from "../../hooks/useValidators";

const EmailVerifyForm = () => {
  const notify = useNotify();
  const { checkAuthFlow } = useAuthMutations(notify);
  const { email } = useValidators();

  const handleSubmit = async (fromData: any) => {
    const data = fromData as { email: string };
    checkAuthFlow(data);
  };

  return (
    <SimpleForm
      className="c-form c-form_email-verify"
      onSubmit={handleSubmit}
      id="c-form_email-verify"
      toolbar={<SaveButton icon={<></>} className="c-form__submit-btn" label="Continue" />}
      mode="onBlur"
      reValidateMode="onBlur"
    >
      <TextInput className="c-form__input c-form__input_text" label="Email" source="email" validate={email} />
    </SimpleForm>
  );
};

export default EmailVerifyForm;
